export class BranchModel {
  branchId: number = 0;
  companyId: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  alterCode2: string | null = null;
  name: string = '';
  address: string = '';
  phone: string = '';
  email: string = '';
  logisticsEmail: string | null = null;
  departmentId: number = 0;
  cityId: number = 0;
  predevolutionObservation: string | null = null;
  devolutionObservation: string | null = null;
  remissionObservation: string | null = null;
  icaInvoiceObservation: string | null = null;
  reteIvaCode: string | null = null;
  reteIvaSaleCode: string | null = null;
  cxcAccount: string | null = null;
  creeDebitAccount: string | null = null;
  creeCreditAccount: string | null = null;
  utilizationAccount: string | null = null;
  canceledInvoiceAccount: string | null = null;
  utilityIvaContractAccount: string | null = null;
  invoiceVoucherCode: string | null = null;
  debitNoteVoucherCode: string | null = null;
  creditNoteVoucherCode: string | null = null;
  cashReceiptVoucherCode: string | null = null;
  invoiceVoucherType: string | null = null;
  creditNoteVoucherType: string | null = null;
  debitNoteVoucherType: string | null = null;
  cashReceiptVoucherType: string | null = null;
  particularConditionRental: string | null = null;
  particularConditionSale: string | null = null;
  quotationObservation: string | null = null;
  swBranchStore: boolean = false;
  storeId: number | null = null;
  swAttachConditions: boolean = false;
  rentalConditions: string | null = null;
  saleConditions: string | null = null;
  createDate: string = '';
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
